export class DateTimeHelper {
  static formatDateTime(date: Date): string {
    if (this.isToday(date)) {
      return date.getHours() + ':' + this.appendLeadingZeroes(date.getMinutes())
    } else {
      return (
        date.getDate() +
        '.' +
        (date.getMonth() + 1) +
        '.' +
        date.getFullYear() +
        ' - ' +
        date.getHours() +
        ':' +
        this.appendLeadingZeroes(date.getMinutes())
      )
    }
  }

  static formatDateTimeFromString(dateString: string): string {
    const date = new Date(dateString)

    return this.formatDateTime(date)
  }

  static isToday(date: Date) {
    const today = new Date()
    return (
      date.getDate() == today.getDate() &&
      date.getMonth() == today.getMonth() &&
      date.getFullYear() == today.getFullYear()
    )
  }

  static appendLeadingZeroes(number: number) {
    if (number <= 9) {
      return '0' + number
    }
    return number
  }

  static getCurrentTimestamp() {
    return Math.floor(Date.now() / 1000)
  }
}
